var React = require('react');

function ArrowRightThin (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Path 82"),React.createElement("path",{"d":"M.862 1.805a.667.667 0 0 1 .943-.943L6.47 5.529c.26.26.26.682 0 .942l-4.666 4.667a.667.667 0 0 1-.943-.943L5.057 6 .862 1.805z","fill":"#6F7881","key":1})]);
}

ArrowRightThin.displayName = "ArrowRightThin";

ArrowRightThin.defaultProps = {"width":"7","height":"12","viewBox":"0 0 7 12"};

module.exports = ArrowRightThin;

ArrowRightThin.default = ArrowRightThin;
